module.exports = __webpack_public_path__ + "img/order.d15103f0.svg";